import { Tournament } from 'models/tournament';
import { useIndividualTournamentLiveData } from './useIndividualTournamentLiveData';

export function useTournamentTVData(tournament: Tournament) {
  const settings: any = tournament.publicBigscreenSite || {};
  const refreshMs = Math.max(15, Number(settings.refreshInterval) || 30) * 1000;
  const { events, isLoading, error } = useIndividualTournamentLiveData(tournament.schoolId, tournament.id, refreshMs);
  return { events, isSync: !isLoading, error };
}
